export enum AnnouncementStatus {
    PUBLISHED = 1,
    DRAFT = 2,
    SCHEDULED = 3,
    EXPIRED = 4
}